import { actionFactory } from 'redux/factories';
import { types } from './types';

export const getCurrencies = actionFactory(types.GET_CUSTOM_CURRENCIES);
export const addCustomCurrency = actionFactory(types.ADD_CUSTOM_CURRENCY);
export const updateCustomCurrency = actionFactory(types.UPDATE_CUSTOM_CURRENCY);
export const deleteCustomCurrency = actionFactory(types.DELETE_CUSTOM_CURRENCY);
